// extracted by mini-css-extract-plugin
module.exports = {"root":"recommend_root_1uXhh","inner":"recommend_inner_22JiG","titlestyle":"recommend_titlestyle_GFzZ0"};